import { render, staticRenderFns } from "./ManageHISPartners.vue?vue&type=template&id=bdfa42e0&scoped=true"
import script from "./ManageHISPartners.vue?vue&type=script&lang=js"
export * from "./ManageHISPartners.vue?vue&type=script&lang=js"
import style0 from "./ManageHISPartners.vue?vue&type=style&index=0&id=bdfa42e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfa42e0",
  null
  
)

export default component.exports